import Layout from "../Frames/Layout";
import Loader from "../Tools/Loader";
import Question from "./Quiz/Question";
import useChoices from "./Hooks/useChoices";
import useQuestions from "./Hooks/useQuestions";
import { Add, ArrowBack } from "@mui/icons-material";
import useCreateQuestion from "./Hooks/useCreateQuestion";
import { DndContext } from "@dnd-kit/core";
import {restrictToVerticalAxis} from '@dnd-kit/modifiers';
import { Button, Stack } from "@mui/material";
import useUpdateChoice from "./Hooks/useUpdateChoice";
import useUpdateQuestion from "./Hooks/useUpdateQuestion";
import { useState } from "react";
import Droppable from "./Common/Droppable";
import { Link, useParams } from "react-router-dom";
import { txt } from "../../services/translation";

export default function Quiz(){

    const {id} = useParams()

    const [dragged, setDragged] = useState({})

    const questions = useQuestions()

    const choices = useChoices()

    const createQuestion = useCreateQuestion()

    const updateChoice = useUpdateChoice()
    const updateQuestion = useUpdateQuestion()
    
    const onDragStart = e => {
        setDragged(e.active?.data?.current);
    }

    const onDragEnd = e => {
        setDragged(null);
        let dragged = {...e.active.data.current};
        let dropped = e.over?.data?.current;
        if(!dropped) return false;
        Object.assign(dragged, dropped);
        return dropped.isChoice ? updateChoice(dragged) : updateQuestion(dragged);
    }

    return <Layout menu='design' tab='plan' title={txt('quiz')} style={{background: 'rgb(250,250,250)'}}>

        {(questions.isFetching || choices.isFetching) ? <Loader /> : 

        <DndContext 
            onDragStart={onDragStart}
            onDragEnd={onDragEnd} 
            modifiers={[restrictToVerticalAxis]}
        >

            <Stack spacing={1} sx={{maxWidth: 800, margin: 'auto'}}>

                <Stack direction='row' justifyContent='space-between' flexWrap='wrap-reverse'>

                    <Button startIcon={<Add />} onClick={() => createQuestion(1)}>
                        {txt('questionButton')}
                    </Button>

                    <Link to={`/design/${id}/plan`}>
                        <Button startIcon={<ArrowBack />}>
                            {txt('returnToPlanButton')}
                        </Button>
                    </Link>

                </Stack>


                <Droppable 
                    id={'question0'}
                    data={{rank: 0, isQuestion: true}}
                    disabled={!dragged?.isQuestion || dragged?.rank === 1}
                />

                {questions.data
                    .sort((a,b) => a.rank - b.rank)
                    .map((c,i) => 
                        <Question 
                            key={c.id} 
                            data={c}
                            choices={choices.isSuccess ? 
                                choices.data.filter(s => s.question?.id === c.id) :
                                []
                            }
                            isFirst={i === 0}
                            isLast={i === questions.data.length - 1}
                            dragged={dragged}
                        />    
                    )}

            </Stack>
        
        </DndContext>}

    </Layout>
    
}